import {AxiosInstance} from 'axios';
import {responseHandler} from './response';
import {GameForecastEndPointResponse} from "./types";
import {EventStatusCode, Event, EventTeam} from "../../types/event";

export type EventModelParams = {
    id?: number
    league_id?: number
    team_home_id?: number
    team_away_id?: number
    status_code?: EventStatusCode
    start_at_start?: string
    start_at_end?: string
}

export type EventTeamModelParams = {
    id?: number
    sport_id?: number
    country_code?: string
    name?: string
}

export const getEvents = async (client: AxiosInstance, params: EventModelParams) => {
    client.defaults.params = params
    return responseHandler<GameForecastEndPointResponse<Event>>(client.get(`/events`))
}

export const getEventTeam = async (client: AxiosInstance, params: EventTeamModelParams) => {
    client.defaults.params = params
    return responseHandler<GameForecastEndPointResponse<EventTeam>>(client.get(`/event-teams`));
}

/**
 * The prediction provider's club behind a club of the team search.
 *
 * The two systems share no identifiers and spell clubs differently, so the pairing is made by the
 * API — which knows both sides, scores the candidates and caches what it settles on — rather than
 * by comparing names here.
 */
export const resolveEventTeam = async (client: AxiosInstance, params: { team_id?: number, name?: string }) => {
    client.defaults.params = params
    return responseHandler<GameForecastEndPointResponse<EventTeam>>(client.get(`/event-teams/resolve`))
}

/**
 * The analysis of a match, predictions included.
 *
 * The listing endpoint hands over fixtures with their predictions stripped: this is the only way to
 * be served one, it needs an active plan, and it spends one of the analyses the plan grants for the
 * day. A match already analysed today is not charged again, so reopening it is free.
 */
export const analyzeEvent = async (client: AxiosInstance, teams: { team_home_id: number, team_away_id: number }) =>
    responseHandler<GameForecastEndPointResponse<Event> & { remainingToday?: number, dailyLimit?: number }>(
        client.post(`/events/analyze`, teams))
